import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { ModalInterceptor } from './interceptors/modal.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';

import { CapitalizePipe } from './capitalize.pipe';
import { LimitarTextoPipe } from './limitar-texto.pipe';
import { KeysPipe } from './keys.pipe';
import { TextMaskModule } from 'angular2-text-mask';

import { WindowService } from './window.service';
import { CoresService } from './cores.service';
import { ScriptExternoService } from './script-externo.service';
import { CidadesService } from './cidades/cidades.service';
import { ModalService } from './modal/modal.service';
import { AuthGuardService } from './guards/auth-guard.service';
import { LoginGuardService } from './guards/login-guard.service';
import { DocumentosService } from './documentos/documentos.service';
import { PageService } from './page.service';
import { CheckoutService } from './checkout/checkout.service';
import { ScrollToService } from './scroll-to.service';
import { AnalyticsService } from './analytics/analytics.service';
import { MigalhasService } from './migalhas/migalhas.service';
import { ModalRecuperarSenhaService } from './modal-recuperar-senha/modal-recuperar-senha.service';
import { AlterarSenhaService } from './alterar-senha/alterar-senha.service';
import { PdfMakeLoaderService } from './pdf-make-loader.service';
import { PessoaService } from './pessoa/pessoa.service';
import { UploadImagemService } from './upload-imagem/upload-imagem.service';
import { BoletoService } from './pagamento/boleto/boleto.service';
import { MathtagService } from './analytics/mathtag/mathtag.service';

import { MapsComponent } from './maps/maps.component';
import { ModalComponent } from './modal/modal.component';
import { CarrosselComponent } from './carrossel/carrossel.component';
import { MigalhasComponent } from './migalhas/migalhas.component';
import { ListaBlocosNoticiasComponent } from './lista-blocos-noticias/lista-blocos-noticias.component';
import { BlocoNoticiaComponent } from './bloco-noticia/bloco-noticia.component';
import { AccordionComponent } from './accordion/accordion.component';
import { PaginacaoComponent } from './paginacao/paginacao.component';
import { AccordionItemComponent } from './accordion/accordion-item/accordion-item.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerCoreComponent } from './spinner/core/spinner.component';
import { SpinnerDirective } from './spinner/directive/spinner.directive';
import { MenuSidebarComponent } from './menu-sidebar/menu-sidebar.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { ImagemResponsivaComponent } from './imagem-responsiva/imagem-responsiva.component';
import { ModalFiltroComponent } from './modal-filtro/modal-filtro.component';
import { LinkGotoSectionDirective } from './link-goto-section.directive';
import { HtmlDecodePipe } from './html-decode.pipe';
import { RedirectToDirective } from './redirect-to.directive';
import { InputCpfDirective } from './input-cpf.directive';
import { UploadImagemComponent } from './upload-imagem/upload-imagem.component';
import { DadosPessoaisFormComponent } from './dados-pessoais-form/dados-pessoais-form.component';
import { PagamentoComponent } from './pagamento/pagamento.component';
import { CartoesCreditoComponent } from './pagamento/cartoes-credito/cartoes-credito.component';
import { AlterarSenhaComponent } from './alterar-senha/alterar-senha.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { ModalRecuperarSenhaComponent } from './modal-recuperar-senha/modal-recuperar-senha.component';

import { ImageCropperModule } from 'ng2-img-cropper';
import { TelefonePipe } from './telefone.pipe';
import { CpfCnpjPipe } from './cpf-cnpj.pipe';
import { FilterPipe } from './filter.pipe';
import { ExtensaoFilter } from './extensao.pipe';
import { StringUtilsService } from './string-utils.service';
import { CartaoResumoCursoComponent } from './cartao-resumo-curso/cartao-resumo-curso.component';
import { LabelBoxComponent } from './label-box/label-box.component';
import { LinkPosInscricaoComponent } from './link-pos-inscricao/link-pos-inscricao.component';
import { AlertBoxComponent } from './alert-box/alert-box.component';
import {NgxImageCompressService} from 'ngx-image-compress';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TextMaskModule,
    ImageCropperModule,
    FormsModule,
    ReCaptchaModule,
    CurrencyMaskModule,
    HttpClientModule
  ],
  declarations: [
    ModalComponent,
    CapitalizePipe,
    FilterPipe,
    ExtensaoFilter,
    LimitarTextoPipe,
    KeysPipe,
    MapsComponent,
    CarrosselComponent,
    MigalhasComponent,
    ListaBlocosNoticiasComponent,
    BlocoNoticiaComponent,
    AccordionComponent,
    PaginacaoComponent,
    AccordionItemComponent,
    SpinnerComponent,
    SpinnerCoreComponent,
    SpinnerDirective,
    MenuSidebarComponent,
    TooltipComponent,
    ImagemResponsivaComponent,
    ModalFiltroComponent,
    LinkGotoSectionDirective,
    HtmlDecodePipe,
    RedirectToDirective,
    InputCpfDirective,
    UploadImagemComponent,
    TelefonePipe,
    CpfCnpjPipe,
    DadosPessoaisFormComponent,
    PagamentoComponent,
    CartoesCreditoComponent,
    AlterarSenhaComponent,
    LoginFormComponent,
    ModalRecuperarSenhaComponent,
    CartaoResumoCursoComponent,
    LabelBoxComponent,
    LinkPosInscricaoComponent,
    AlertBoxComponent,
  ],
  exports: [
    RouterModule,
    ModalComponent,
    CapitalizePipe,
    FilterPipe,
    ExtensaoFilter,
    LimitarTextoPipe,
    KeysPipe,
    HtmlDecodePipe,
    MapsComponent,
    CarrosselComponent,
    MigalhasComponent,
    ListaBlocosNoticiasComponent,
    BlocoNoticiaComponent,
    AccordionComponent,
    PaginacaoComponent,
    AccordionItemComponent,
    SpinnerComponent,
    SpinnerCoreComponent,
    SpinnerDirective,
    MenuSidebarComponent,
    TextMaskModule,
    TooltipComponent,
    ImagemResponsivaComponent,
    ModalFiltroComponent,
    LinkGotoSectionDirective,
    RedirectToDirective,
    InputCpfDirective,
    UploadImagemComponent,
    TelefonePipe,
    CpfCnpjPipe,
    DadosPessoaisFormComponent,
    PagamentoComponent,
    AlterarSenhaComponent,
    LoginFormComponent,
    ModalRecuperarSenhaComponent,
    CartaoResumoCursoComponent,
    LabelBoxComponent,
    LinkPosInscricaoComponent,
    AlertBoxComponent,
  ],
  providers: [
    WindowService,
    ModalService,
    AuthGuardService,
    LoginGuardService,
    CoresService,
    CheckoutService,
    CidadesService,
    DocumentosService,
    PageService,
    PdfMakeLoaderService,
    PessoaService,
    ScrollToService,
    AnalyticsService,
    BoletoService,
    NgxImageCompressService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ModalInterceptor,
      multi: true,
    },
    UploadImagemService,
    CapitalizePipe,
    FilterPipe,
    ExtensaoFilter,
    MigalhasService,
    CpfCnpjPipe,
    ModalRecuperarSenhaService,
    AlterarSenhaService,
    StringUtilsService,
    MathtagService,
    ScriptExternoService,
  ],
  entryComponents: [
    SpinnerCoreComponent,
  ],
})
export class SharedModule { }
